import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import "../../../../style/WarrantyCard.css";

interface WarrantyCardProps {
  data: {
    patientName: string;
    mobile: string;
    treatment: string;
    toothNumber: string;
    material: string;
    warrantyMonths: number;
    validTill: string;
    warrantyNumber: string;
    dentistName:string;
  };
}

const formatDate = (dateString: string) => {
  if (!dateString) return "-";

  const date = new Date(dateString);

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};
const WarrantyCard: React.FC<WarrantyCardProps> = ({ data }) => {
  return (
    <div className="warranty-card" id="print-area">

      <div className="warranty-header">
        <div>
          <h2>TOOTHZAP</h2>
          <span>Dental Warranty Card</span>
        </div>

      </div>

      <div className="warranty-divider" />

      <div className="card-body material-card">

        {/* LEFT SIDE */}
        <div className="card-left">
          <div className="row-material">
            <span>Patient</span>
            <strong>{data.patientName}</strong>
          </div>

          <div className="row-material ">
            <span>Mobile</span>
            <strong>{data.mobile}</strong>
          </div>

          <div className="row-material">
            <span>Treatment</span>
            <strong>{data.treatment}</strong>
          </div>

          
          <div className="row-material">
            <span>Dentist</span>
            <strong>{data.dentistName}</strong>
          </div>
        </div>
       


        

        {/* RIGHT SIDE */}
        <div className="card-right">
          <div className="row-material">
            <span>Tooth No</span>
            <strong>{data.toothNumber}</strong>
          </div>

          <div className="row-material">
            <span>Material</span>
            <strong>{data.material}</strong>
          </div>

         <div className="row-material">
  <span>Valid Till</span>
  <strong>{formatDate(data.validTill)}</strong>
</div>
        </div>

      </div>

      <div className="warranty-divider" />

      <div className="warranty-footer">
        <div>
          <small>Warranty No</small>
          <h4>{data.warrantyNumber}</h4>
        </div>

        <div className="qr">
          <QRCodeCanvas
            value={data.warrantyNumber}   // 👈 This is what scanner will read
            size={50}
            bgColor="#ffffff"
            fgColor="#000000"
            level="H"
            includeMargin={true}
          />
        </div>





      </div>

    </div>
  );
};

export default WarrantyCard;